import ErrorIcon from "@mui/icons-material/Warning";
import WarningIcon from "@mui/icons-material/Report";
import SettingsIcon from "@mui/icons-material/Settings";
import InfoIcon from "@mui/icons-material/Info";
import BugReportIcon from "@mui/icons-material/BugReport";
import { AlertColors, AlertIcons, AlertLevelClass, levelToClass } from "./alert_enums";

export default function AlertIcon({ level, icon, style }) {
  if (icon === AlertIcons.DEBUG) {
    return <BugReportIcon htmlColor={iconColor(level)} sx={style} />;
  } else if (icon === AlertIcons.INFO) {
    return <InfoIcon htmlColor={iconColor(level)} sx={style} />;
  } else if (icon === AlertIcons.WARNING) {
    return <WarningIcon htmlColor={iconColor(level)} sx={style} />;
  } else if (icon === AlertIcons.ERROR) {
    return <ErrorIcon htmlColor={iconColor(level)} sx={style} />;
  } else if (icon === AlertIcons.SETTINGS) {
    return <SettingsIcon htmlColor={iconColor(level)} sx={style} />;
  } else if (icon === AlertIcons.CRITICAL) {
    return <ErrorIcon htmlColor={iconColor(level)} sx={style} />;
  }
}

function iconColor(level) {
  switch (levelToClass(level)) {
    case AlertLevelClass.DEBUG:
      return AlertColors.DEBUG;
    case AlertLevelClass.LOG:
      return AlertColors.LOG;
    case AlertLevelClass.INFO:
      return AlertColors.INFO;
    case AlertLevelClass.WARNING:
      return AlertColors.WARNING;
    case AlertLevelClass.ERROR:
      return AlertColors.ERROR;
    case AlertLevelClass.CRITICAL:
      return AlertColors.CRITICAL;
  }
}
